import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  Box,
} from "@mui/material";
import PropTypes from "prop-types";

const AddRegionModal = ({ open, onClose, onAddRegion, managers }) => {
  const [newRegion, setNewRegion] = useState({
    name: "",
    description: "",
    managerId: "",
  });

  const handleChange = (e) => {
    setNewRegion({ ...newRegion, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    onAddRegion(newRegion);
    // Optionally reset the form after submission:
    setNewRegion({ name: "", description: "", managerId: "" });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Region</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <TextField
            name="name"
            label="Region Name"
            fullWidth
            margin="normal"
            value={newRegion.name}
            onChange={handleChange}
          />
          <TextField
            name="description"
            label="Description"
            fullWidth
            margin="normal"
            value={newRegion.description}
            onChange={handleChange}
          />
          <Select
            name="managerId"
            fullWidth
            value={newRegion.managerId}
            onChange={handleChange}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select a Region Manager
            </MenuItem>
            {managers.map((manager) => (
              <MenuItem key={manager.id} value={manager.id}>
                {manager.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddRegionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAddRegion: PropTypes.func.isRequired,
  managers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AddRegionModal;
